// extracted by mini-css-extract-plugin
export var deleteModal = "_fb-0";